import { useStore } from 'vuex';

export function useShippingDispatch() {
  const store = useStore();

  const sendShippingInfo = (paymentMethod, paymentTransaction) => {
    if (paymentTransaction?.transactionId) {
      console.log('✅ Pago con tarjeta completado, enviando shipping');
      dispatchShipping();
      return;
    }

    switch (paymentMethod) {
      case 'paypal':
        console.log('✅ Pago con PayPal completado, enviando shipping');
        dispatchShipping();
        break;
      case 'card':
        console.log('✅ Pago con tarjeta completado, enviando shipping');
        dispatchShipping();
        break;
      default:
        if (paymentMethod) {
          console.log('📤 Enviando shipping...');
          dispatchShipping();
        } else {
          console.log('⚠️ No hay método de pago definido');
        }
    }
  };

  const dispatchShipping = () => {
    store.dispatch('sendStatusShipping');
    store.dispatch('sendShipping');
  };

  return {
    sendShippingInfo
  };
}
